import { createTheme } from '@mui/material'

export const theme = createTheme({
  components: {
    MuiCssBaseline: {
      styleOverrides: {
        '*': {
          margin: 0,
          padding: 0,
        },
        'html, body, #root': {
          height: '100%',
          width: '100%',
        },
        ul: {
          listStyle: 'none',
          backgroundColor: '#f9f9f9',
        },
        li: {
          backgroundColor: '#f9f9f9',
          width: '100%',
        },
      },
    },
    MuiSvgIcon: {
      styleOverrides: {
        root: { verticalAlign: 'middle' },
      },
    },
  },
})
